<!-- src/components/common/ToastContainer.vue -->
<!-- Vuetify 3 Top-Right Toast Notifications Container -->
<template>
  <div class="toast-stack-container" aria-live="polite">
    <TransitionGroup name="toast-slide">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast-item-wrapper"
      >
        <v-alert
          :color="toast.color"
          :icon="toast.icon"
          variant="tonal"
          density="comfortable"
          elevation="8"
          rounded="lg"
          closable
          class="toast-alert"
          @click:close="removeToast(toast.id)"
        >
          <div class="toast-text">{{ toast.msg }}</div>
        </v-alert>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from '../../composables/useToast.js'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toast-stack-container {
  position: fixed;
  top: 18px;
  right: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 99999;
  max-width: 420px;
  width: calc(100vw - 36px);
  pointer-events: none;
}

.toast-item-wrapper {
  pointer-events: auto;
}

.toast-alert {
  background: rgba(15, 23, 42, 0.9) !important;
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5) !important;
}

.toast-text {
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.4;
  color: #f8fafc;
  word-break: break-word;
}

/* Slide and Fade Transitions from Top-Right */
.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-slide-enter-from {
  opacity: 0;
  transform: translateX(40px) scale(0.95);
}

.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(30px) scale(0.9);
}

.toast-slide-move {
  transition: transform 0.25s ease;
}
</style>
